import { CustomTemplatedMessageVariables } from 'generated-graphql/types';
import { CampaignType } from 'services/campaign/types';

export const getCampaignCreationTemplateVariables = (
  campaignType: CampaignType | null | undefined
) => {
  if (campaignType === CampaignType.ENGAGEMENT_OUTREACH) {
    return [
      CustomTemplatedMessageVariables.CandidateFirstName,
      CustomTemplatedMessageVariables.CandidateLastName,
      CustomTemplatedMessageVariables.AgentName,
      CustomTemplatedMessageVariables.OrganizationName
    ];
  }

  if (
    campaignType === CampaignType.NEW_CANDIDATE_OUTREACH ||
    campaignType === CampaignType.APPLICANT_OUTREACH
  ) {
    return [
      CustomTemplatedMessageVariables.CandidateFirstName,
      CustomTemplatedMessageVariables.CandidateLastName,
      CustomTemplatedMessageVariables.AgentName,
      CustomTemplatedMessageVariables.EmployerName,
      CustomTemplatedMessageVariables.JobTitle,
      CustomTemplatedMessageVariables.Location,
      CustomTemplatedMessageVariables.OrganizationName
    ];
  }

  if (campaignType === CampaignType.HUMAN_OUTREACH) {
    return [
      CustomTemplatedMessageVariables.CandidateFirstName,
      CustomTemplatedMessageVariables.CandidateLastName,
      CustomTemplatedMessageVariables.JobTitle,
      CustomTemplatedMessageVariables.EmployerName,
      CustomTemplatedMessageVariables.Location,
      CustomTemplatedMessageVariables.OrganizationName
    ];
  }

  if (
    campaignType === CampaignType.ATS_JOB_APPLICATION_URL_OUTREACH ||
    campaignType === CampaignType.CUSTOM_JOB_APPLICATION_URL_OUTREACH
  ) {
    return [
      CustomTemplatedMessageVariables.CandidateFirstName,
      CustomTemplatedMessageVariables.CandidateLastName,
      CustomTemplatedMessageVariables.CandidateRelevance,
      CustomTemplatedMessageVariables.JobTitle,
      CustomTemplatedMessageVariables.Location,
      CustomTemplatedMessageVariables.OrganizationName,
      CustomTemplatedMessageVariables.JobApplicationUrl,
      CustomTemplatedMessageVariables.AgentName,
      CustomTemplatedMessageVariables.EmployerName
    ];
  }

  if (campaignType === CampaignType.REQUEST_CV_OUTREACH) {
    return [
      CustomTemplatedMessageVariables.CandidateFirstName,
      CustomTemplatedMessageVariables.CandidateLastName,
      CustomTemplatedMessageVariables.CandidateRelevance,
      CustomTemplatedMessageVariables.JobTitle,
      CustomTemplatedMessageVariables.Location,
      CustomTemplatedMessageVariables.OrganizationName,
      CustomTemplatedMessageVariables.EmployerName,
      CustomTemplatedMessageVariables.AgentName
    ];
  }

  return [];
};
